import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Tabs from "../../components/common/Tabs";

const tabs = [
  {
    link: "/accounting/receivables_payments",
    title: "Recievables",
  },
  {
    link: "/accounting/payables_bills",
    title: "Payables",
  },
  {
    link: "/accounting/bank_accounts",
    title: "Bank Accounts",
  },
  {
    link: "/accounting/bank_transfers_incomplete",
    title: "Bank Transfers",
  },
  {
    link: "/accounting/gl-accounts",
    title: "GL Accounts",
  },
];

function Accounting() {
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} />
        <Outlet />

        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default Accounting;
